export enum WatermarkType {
  TEXT = 'text',
  IMAGE = 'image'
}

export enum WatermarkLayer {
  BOTTOM = 'bottom',
  TOP = 'top'
}